import { graphql } from '@/gql';
import type { DeletePaymentSourceMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deletePaymentSource = async ({ userId, cardId, notes }: DeletePaymentSourceMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeletePaymentSource($userId: String!, $cardId: String!, $notes: String!) {
        deletePaymentSource(userId: $userId, cardId: $cardId, notes: $notes)
      }
    `),
    variables: {
      userId,
      cardId,
      notes,
    },
  });

  return response.data?.deletePaymentSource ?? false;
};
